import UserContainer from './UserContainer'
import BasketContainer from './BasketContainer'
import HamburgerContainer from './HamburgerContainer'
import featureToggles from 'shared/featureToggles'

const NavRightResponsive = () => (
    <div className="nav-right">
        <ul className="horizontal-list">
            <li>
                <UserContainer isResponsive={true} />
            </li>
            {featureToggles.hasBasket && (
                <li>
                    <BasketContainer />
                </li>
            )}
            <li>
                <HamburgerContainer />
            </li>
        </ul>
    </div>
)

export default NavRightResponsive
